function u(i) {
  return function(e, l, f) {
    for (var s = -1, r = Object(e), a = f(e), t = a.length; t--; ) {
      var n = a[i ? t : ++s];
      if (l(r[n], n, r) === !1)
        break;
    }
    return e;
  };
}
var o = u;
export {
  o as default
};
//# sourceMappingURL=_createBaseFor.js.map
